/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Heading, VFlow } from 'bold-ui'
import { useHistoricoVacinacaoDwQuery } from 'graphql/hooks.generated'
import { HistoricoVacinacaoDwQuery } from 'graphql/types.generated'
import { isEmpty } from 'lodash'
import { Fragment } from 'react'
import { filterByRegistroAnterior } from 'view/atendimentos/detail/historico/utils/filterByRegistroAnterior'

import CondicoesVacinacao from '../CondicoesVacinacao'
import HistoricoVacinacaoBoxTable from '../HistoricoVacinacaoBoxTable'
import HistoricoVacinacaoDwTableItem from './HistoricoVacinacaoDwTableItem'

export interface HistoricoVacinacaoProcessadosProps {
  cpfOuCnsCidadao: string
  uuidAtend: string
}

export type HistoricoVacinacaoDwModel = HistoricoVacinacaoDwQuery['historicoVacinacaoDw']['fatosVacinacaoVacina'][0]

export default function HistoricoVacinacaoDw(props: HistoricoVacinacaoProcessadosProps) {
  const { uuidAtend, cpfOuCnsCidadao } = props
  const {
    data: { historicoVacinacaoDw: historico },
  } = useHistoricoVacinacaoDwQuery({
    variables: {
      input: {
        uuidAtend,
        cpfOuCnsCidadao,
        isOrigemPec: false,
      },
    },
  })

  const { recentes, registroAnterior } = filterByRegistroAnterior<HistoricoVacinacaoDwModel>(
    historico?.fatosVacinacaoVacina
  )

  const renderItem = (item: HistoricoVacinacaoDwModel) => HistoricoVacinacaoDwTableItem(item)

  return (
    <Fragment>
      {historico && (
        <VFlow>
          <CondicoesVacinacao
            gestante={historico.gestante}
            puerpera={historico.puerpera}
            viajante={historico.viajante}
            comunicanteHanseniase={historico.comunicanteHanseniase}
          />
          <VFlow vSpacing={0.5}>
            <Heading level={3}>Vacinação</Heading>
            {!isEmpty(recentes) && (
              <HistoricoVacinacaoBoxTable<HistoricoVacinacaoDwModel> items={recentes} renderItem={renderItem} />
            )}
            {!isEmpty(registroAnterior) && (
              <HistoricoVacinacaoBoxTable<HistoricoVacinacaoDwModel>
                registroAnterior
                items={registroAnterior}
                renderItem={renderItem}
              />
            )}
          </VFlow>
        </VFlow>
      )}
    </Fragment>
  )
}
